module.exports = __webpack_public_path__ + "static/media/state-pension.ca39e13f.svg";